export default __webpack_public_path__ + "e25831a7f415d0bdf99569a26e53348a.webp";